module.exports = __webpack_public_path__ + "static/img/liujiren.db06bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/liujiren.png
// module id = v+yi
// module chunks = 0